import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../components/context/AuthContext';

const DashboardRedirect = () => {
    const { perfil, idColaborador } = useAuth();
    const [id] = useState(idColaborador); // no necesitas setId si no lo usas

    if (!perfil) return null; // puedes mostrar un <Spinner /> si quieres

    console.log('mira mi perfil:', perfil);

    switch (perfil) {
        case 'EmployeCenterColaborador':
            return <Navigate to={`/app/PerfilColaborador/${id}`} replace />;

        case 'EmployeCenterAdministrator':
            return <Navigate to="/app/starter" replace />;

        default:
            return <Navigate to="/app/PerfilColaborador" replace />;
    }
};

export default DashboardRedirect;
